export default __webpack_public_path__ + "static/media/ME-Azure.3cf0091c.png";